class AddressFormatService {
  format(line1 = "-", houseNumber = "-", line2 = "-") {

    if (!line2) {
      line2 = '';
    }

    return `${line1} ${houseNumber} ${line2}`;
  }
}

export default new AddressFormatService();
